import { useEffect, useState } from "react";
import { safelyGetItem, safelySetItem } from "storefront/lib/Storage";

const LOCAL_STORAGE_KEY = "accountHealth";

export const useAccountHealthStatus = () => {
  const [hasViewed, setHasViewed] = useState(true);

  useEffect(() => {
    const viewed = safelyGetItem(localStorage)(LOCAL_STORAGE_KEY) === "true";
    setHasViewed(viewed);
  }, []);

  const markAsViewed = () => {
    if (hasViewed) return;
    safelySetItem(localStorage)(LOCAL_STORAGE_KEY, "true");
    setHasViewed(true);
  };

  return { hasViewed, markAsViewed };
};
